/* eslint-disable import/extensions, max-len, prettier/prettier */
import { takeLatest, call, put } from 'redux-saga/effects';
import {
  getDiscountsList,
  getOffersProducts,
  performOfferAction,
  createDiscount,
  updateDiscount,
  searchEligibleProducts,
} from './api';
import {
  fetchDiscountsListSuccess,
  fetchDiscountsListFail,
  searchProductsSuccess,
  searchProductsFail,
  createDiscountSuccess,
  createDiscountFail,
  updateDiscountSuccess,
  updateDiscountFail,
  fetchOffersProductsSuccess,
  fetchOffersProductsFail,
  performOfferActionSuccess,
  performOfferActionFail,
} from './actions';
import discountsActionTypes from './action-types';

function* fetchDiscountsListSaga({ payload }) {
  try {
    const response = yield call(getDiscountsList, payload);
    yield put(fetchDiscountsListSuccess(response));
  } catch (error) {
    yield put(fetchDiscountsListFail(error));
  }
}

function* searchProductsSaga({ payload }) {
  try {
    const params = typeof payload === 'string' ? { searchTerm: payload, pageNumber: 1, pageSize: 20 } : payload;
    const response = yield call(searchEligibleProducts, params);
    yield put(searchProductsSuccess(response));
  } catch (error) {
    yield put(searchProductsFail(error));
  }
}

function* createDiscountSaga({ payload }) {
  try {
    yield call(createDiscount, payload);
    yield put(createDiscountSuccess());
  } catch (error) {
    yield put(createDiscountFail(error));
  }
}

function* updateDiscountSaga({ payload }) {
  try {
    yield call(updateDiscount, payload);
    yield put(updateDiscountSuccess());
  } catch (error) {
    yield put(updateDiscountFail(error));
  }
}

function* fetchOffersProductsSaga({ payload }) {
  try {
    const response = yield call(getOffersProducts, payload);
    yield put(fetchOffersProductsSuccess(response));
  } catch (error) {
    yield put(fetchOffersProductsFail(error));
  }
}

function* performOfferActionSaga({ payload }) {
  try {
    yield call(performOfferAction, payload);
    yield put(performOfferActionSuccess());
  } catch (error) {
    yield put(performOfferActionFail(error));
  }
}

function* discountsSagas() {
  yield takeLatest(discountsActionTypes.FETCH_DISCOUNTS_LIST, fetchDiscountsListSaga);
  yield takeLatest(discountsActionTypes.FETCH_OFFERS_PRODUCTS, fetchOffersProductsSaga);
  yield takeLatest(discountsActionTypes.PERFORM_OFFER_ACTION, performOfferActionSaga);
  yield takeLatest(discountsActionTypes.SEARCH_PRODUCTS, searchProductsSaga);
  yield takeLatest(discountsActionTypes.CREATE_DISCOUNT, createDiscountSaga);
  yield takeLatest(discountsActionTypes.UPDATE_DISCOUNT, updateDiscountSaga);
}

export default discountsSagas;
